/**
 * iterate over all moved and cloned items, and update their z-indexes so that
 * they are incremental
 *
 * we're doing so by sorting by their current z-index, and then resetting
 * z-index based on each item's index in the collection
 */
function arrangeZIndexes(draftPageEntry) {
  const movedItems = Object.keys(draftPageEntry.items)
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  .map(itemId => draftPageEntry.items[itemId]).filter(item => item.zIndex !== undefined);
  const clonedItems = draftPageEntry.clones;
  const dynamicItems = [...movedItems, ...clonedItems];
  dynamicItems.sort((a, b) => (a.zIndex ?? 0) - (b.zIndex ?? 0)).forEach((item, index) => {
    item.zIndex = index + 1;
  });
}

export { arrangeZIndexes };
//# sourceMappingURL=arrange-z-indexes.js.map
